module.exports = __webpack_public_path__ + "img/puzzles-survival.6b90825.png";